import * as React from 'react';
import { LinkText, Text } from '@origin-digital/style-guide';
import { Box } from '@origin-digital/layout';
import { AuthCard } from '../../../../components/Card';
import styled from 'styled-components';
import { CenteredHeading } from '../../../../components/CentredHeading';
import { CancelIcon } from '@origin-digital/icon';
import { Page } from '../../../../components/Page';

interface ErrorViewProps {
  errorMessage: string;
  title: string;
  backHref: string;
  onBackButtonClicked?: () => void;
}

const ErrorView: React.FC<ErrorViewProps> = ({
  backHref,
  onBackButtonClicked,
  errorMessage,
  title,
}) => (
  <Page>
    <AuthCard>
      <CardContent>
        <Box marginBottom={6}>
          <CancelIcon data-id="error-icon" color={'redPink'} size={40} />
        </Box>
        <Box marginBottom={4}>
          <CenteredHeading data-id="error-title" text={title} />
        </Box>
        <Box marginBottom={6}>
          <Text size="sm" overflow="normal" data-id="error-msg" markdown={true}>
            {`${errorMessage}`}
          </Text>
        </Box>
        <Box alignContent="center">
          <LinkText
            color="red"
            data-id="error-back-button"
            onClick={onBackButtonClicked}
            href={backHref}
            text="Go Back"
          />
        </Box>
      </CardContent>
    </AuthCard>
  </Page>
);

const CardContent = styled.div`
  text-align: center;
`;

export { ErrorView };
